// extracted by mini-css-extract-plugin
export default {"schedule":"schedule_schedule__gFrcb","cardsList":"schedule_cardsList__5l1KJ"};